module.exports = __webpack_public_path__ + "img/dhht-8.f67a8da8.png";